import { Role } from '@guiker/permissions'

import { TenantApplicationRoleNames } from '../role-names'
import { TenantApplicationActions } from '../tenant-application-actions'

export const TenantRole: Role = {
  name: TenantApplicationRoleNames.TENANT,
  permissions: Object.values(TenantApplicationActions).map((action) => ({ action })),
}
